import React, { useState } from "react";
import { TouchableOpacity } from "react-native";

import { Input, Picker } from "components";

export const DivisionQuestion = props => {
  const { divisionInfo, division, divisions, setDivision } = props;
  const { validateCurrentSection } = props;

  const [isPickerVisible, setPickerVisible] = useState(false);

  const selectDivision = div => {
    setDivision(div);
    validateCurrentSection();
    setPickerVisible(false);
  };

  return (
    <TouchableOpacity onPress={() => setPickerVisible(true)} activeOpacity={1}>
      <Input
        value={division.title}
        placeholder={divisionInfo.label}
        pointerEvents="none"
        fullscreen={false}
        editable={false}
      />
      <Picker
        visible={isPickerVisible}
        options={divisions}
        textKey="title"
        onPress={selectDivision}
      />
    </TouchableOpacity>
  );
};
